<template>
  <li role="presentation" :class="$attrs.class" :style="$attrs.style">
    <router-link v-if="to"
                 v-bind="linkAttrs"
                 :to="to"
                 class="dropdown-item"
                 :class="linkClass"
                 role="menuitem"
                 target="_self"
                 @click="onClick"><slot/></router-link>
    <a v-else
       v-bind="linkAttrs"
       class="dropdown-item"
       :class="linkClass"
       role="menuitem"
       :href="href || '#'"
       :target="target"
       :rel="target === '_blank' ? 'noopener' : null"
       @click="onClick"><slot/></a>
  </li>
</template>

<script setup>
// Replaces bootstrap-vue's <b-dropdown-item> with the same markup and behaviour (only what the app uses).
// Reference: node_modules/bootstrap-vue/src/components/dropdown/dropdown-item.js and .../link/link.js
import { computed, inject, useAttrs } from "vue"

defineOptions({
  name: 'BDropdownItem',
  // class and style go to the <li>, everything else to the link
  inheritAttrs: false
})

const props = defineProps({
  href: {
    type: String,
    default: null
  },
  target: {
    type: String,
    default: '_self'
  },
  to: {
    type: [String, Object],
    default: null
  },
  linkClass: {
    type: [String, Array, Object],
    default: null
  }
})

const emit = defineEmits(['click'])

const attrs = useAttrs()
const bvDropdown = inject('bvDropdown', null)

const linkAttrs = computed(() => {
  const rest = { ...attrs }
  delete rest.class
  delete rest.style
  return rest
})

const onClick = (event) => {
  emit('click', event)
  // href="#" is only a placeholder, the page must not jump to the top
  if(!props.to && (props.href || '#') === '#') event.preventDefault()
  requestAnimationFrame(() => {
    if(bvDropdown) bvDropdown.hide(true)
  })
}
</script>
